/**
 * TODO: Create reusable button component
 * TODO: Make input fields reusable
 */
/**
 * Step2 subpage that is used for `components/subpages/migration.jsx` when a visitors is at the `step2` phase of the migration process.
 *
 * <i>Copyright (c) 2019 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module components/subpages/migration/step2.jsx
 * @class MigrationStep2
 * @since 0.0.1
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Web3 from 'web3';
import {TextField} from '@rmwc/textfield';
import {Button} from '@rmwc/button';
import {Confirm} from '../../SvgIcons';
import translations from '../../../lib/translations';

class Steps2 extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.props = props;
        this.translate = translations.init(props);
    }
    /**
   * Checkes whether the input is ok and the user is allowed to proceed to step3.
   *
   * @method mayProceed
   * @return {Boolean} whether proceeding to step3 is allowed
   * @since 0.0.1
   */
    mayProceed() {
        return this.validGen3Address(this.props.gen3Address);
    }

    /**
   * Validates whether the user input has the right length for a Gen3 Address.
   *
   * @method validGen3Address
   * @param address {String} Hexadecimal Gen3 address, must be prepended with '0x'
   * @return {ReactComponent}
   * @since 0.0.1
   */
    validGen3Address(address) {
        return (typeof address === 'string') && Web3.utils.isAddress(address);
    }

    /**
   * Method for marking a step as completed
   * @method handleStepCompletion
   * @param {*} value
   * @since 0.0.2
   */
    handleStepCompletion(value) {
        this.props.handleChangeStep(value);
        this.props.completeStep2(true);
        window.scrollTo(0, this.myRef.current.offsetTop - 80);
    }

    render() {
        const instance = this,
            props = instance.props,
            translate = instance.translate;
        let confirm;

        if (props.step2 && props.hasBalance) {
            confirm = <Confirm />;
        }

        const isActive = props.step === 2 ? 'active' : null;
        const isApproved = (props.step2 && props.hasBalance) ? 'approved' : null;
        return (
            <div className="step2" ref={this.myRef}>
                <div className="step-head">
                    <h3 className={`${isActive} ${isApproved}`}>{translate.t('STEP2')}.</h3>
                    {confirm}
                </div>

                {this.props.step === 2 && (
                    <div className="details">
                        <p>{translate.t('ENTER_GEN3_WALLET', true)}:</p>

                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                label={translate.t('ENTER_GEN3_ADDRESS', true)}
                                onChange={this.props.onChangeGen3Address}
                                outlined
                                value={this.props.gen3Address}/>
                        </div>

                        <div className="buttons">
                            <Button
                                className="button-step2"
                                disabled={!this.mayProceed() || this.props.loading || !this.props.hasBalance}
                                label={translate.t('CONTINUE', true)}
                                onClick={() => this.handleStepCompletion(3)}
                                unelevated/>
                            <Button
                                className="button-step2"
                                label={translate.t('BACK', true)}
                                onClick={() => this.props.handleChangeStep(1)}
                                unelevated/>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Steps2;

Steps2.defaultProps = {
    loading: false,
};

Steps2.propTypes = {
    completeStep2: PropTypes.func.isRequired,
    gen3Address: PropTypes.string.isRequired,
    handleChangeStep: PropTypes.func.isRequired,
    hasBalance: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    onChangeGen3Address: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
    step2: PropTypes.bool.isRequired,
};
